import React from "react";

import styled from "styled-components";
import breakpoints from "../constants/breakpoints";
import { siteColors } from "../constants/colors";
import {
  Band,
  BandTextContainer,
  BandTextHeader,
  BandBodyText,
} from "./band";
import { AdaptiveHostedVideo } from "./hosted-video.js";
import { VideoContainer, VideoInnerContainer } from "./ephemeral-video-container.js";

const TextMarginTopAdjustmentContainer = styled.div`
   margin-top: -4.5em;

  @media (max-width: ${ breakpoints.desktopSmallHD }px) {
   margin-top: 2.0em;
  }
`;

const VideoMarginAdjustmentContainer = styled.div`
   margin-right: 6.5em;
   margin-left: -6.5em;

  @media (max-width: ${ breakpoints.desktopSmallHD }px) {
   margin-right: 0.0em;
   margin-left: 0.0em;
  }
`;

const InbetweensBand = () => (
  <Band background={siteColors.darker}>
    <BandTextContainer>
        <TextMarginTopAdjustmentContainer>
      <BandTextHeader>
        Use inbetweens, not splines
      </BandTextHeader>
      <BandBodyText>
        Spline-interpolated keyframes were never designed to support a
        traditional pose to pose workflow, so TDs had to build an ever-growing
        tower of bandaids and hacks on top of them to make it viable.
      </BandBodyText>
      <BandBodyText>
        The Ephemeral Animation System does away with spline-interpolated
        keyframes; instead, a robust set of breakdown and inbetweening tools
        lets you treat poses like infiitely-editable drawings.
      </BandBodyText>
        </TextMarginTopAdjustmentContainer>
    </BandTextContainer>
        <VideoContainer>
        <VideoInnerContainer>
        <VideoMarginAdjustmentContainer>
        <AdaptiveHostedVideo url="https://www.youtube.com/embed/DgiVh-ivRvM?si=cJF0GZKswZYIIQzt" title="Ephemeral Inbetweening" />
        </VideoMarginAdjustmentContainer>
        </VideoInnerContainer>
        </VideoContainer>
  </Band>
);

export default InbetweensBand;
